import ActionTypes from './container/actionType';

const editReducers = (state = {
    userInfo: [],
    loader: false,
    message: ''
}, action) => {
    switch (action.type) {
        case ActionTypes.EditProfile: {
            return state = {
                ...state,
                userInfo: action.payload
            }
        }
        case ActionTypes.EditLoader: {
            return state = {
                ...state,
                loader: !state.loader
            }
        }
        case ActionTypes.EditMessage: {
            return state = {
                ...state,
                message: action.payload
            }
        }
        default: { }
    }
    return state;
}
export default editReducers;


// WEBPACK FOOTER //
// ./src/reducers/editReducers.jsx